/**
 * @module core/dashboard/config
 * @description 报表栅格默认尺寸与 GridLayout 运行时配置。
 *
 * @core SaveModel（多维/探索/AB）、CreateReport 新建卡片与 DashboardLayout 拖拽共用。
 */

import { ChartType } from '@dbl/core/chart';
import { AI_ANALYSIS_TYPE, FILTER_WRAP_I } from './constants';
import type { ILayoutItemDefaultOption } from './types';

/**
 * 按卡片 / 图表类型索引的默认栅格 w/h（及 filterWrap 完整布局项）。
 *
 * @core 新建卡片时从 layoutItemOption[chartType] 取默认尺寸。
 */
export const layoutItemOption: ILayoutItemDefaultOption = {
  filterWrap: {
    i: FILTER_WRAP_I,
    x: 0,
    y: 0,
    w: 12,
    h: 3,
    static: true,
    isDraggable: false,
    isResizable: false,
  },
  tab: {
    w: 12,
    h: 2,
  },
  filter: {
    w: 12,
    h: 2,
  },
  userFilter: {
    w: 12,
    h: 2,
  },
  default: {
    w: 6,
    h: 7,
  },
  Table: {
    w: 12,
    h: 15,
  },
  text: {
    w: 12,
    h: 2,
  },
  [ChartType.BigNumber]: {
    w: 3,
    h: 3,
  },
  [ChartType.Trend]: {
    w: 3,
    h: 4,
  },
  [ChartType.DimNumberTrend]: {
    w: 4,
    h: 5,
  },
  [ChartType.Map]: {
    w: 6,
    h: 8,
  },
  [AI_ANALYSIS_TYPE]: {
    w: 12,
    h: 7,
  },
};

/** react-grid-layout 全局配置（列数、行高、紧凑模式）。 */
export const gridLayoutConfig = {
  cols: 12,
  rowHeight: 36,
  compactType: 'vertical' as const,
  allowOverlap: false,
};

/** 筛选器操作区默认栅格尺寸。 */
export const filterOperateConfig = {
  w: 6,
  h: 1,
};
